<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 15C4 14.4477 4.44772 14 5 14H15C15.5523 14 16 14.4477 16 15C16 15.5523 15.5523 16 15 16H5C4.44772 16 4 15.5523 4 15Z"
      fill="currentColor"
    />
    <path
      d="M4 5C4 4.44772 4.44772 4 5 4H15C15.5523 4 16 4.44772 16 5V11C16 11.5523 15.5523 12 15 12H5C4.44772 12 4 11.5523 4 11V5Z"
      fill="currentColor"
    />
  </svg>
</template>
